import { AppBar, Row } from "@commonlibs";
import styled, { css } from "styled-components";

export const AppBarRoot = styled(AppBar).attrs({ position: "fixed", elevation: 0 })(
    () => css`
        top: 0;
        left: 0;
        height: var(--appbar-height);
        max-height: var(--appbar-height);
        min-height: var(--appbar-height);
    `,
);

export const AppBarHeader = styled(Row)(
    ({ theme }) => css`
        padding: ${theme.spacing.all(4, 6, 0)};
    `,
);

export const AppBarHeaderContent = styled(Row)(
    ({ theme }) => css`
        column-gap: 1.5rem;
        ${theme.breakpoints.down("mobile")} {
            column-gap: 0.75rem;
        }
    `,
);
